import apiUrl from '../../../constants'
import axios from 'axios'
import GroupMapping from './GroupMapping/index.vue';
import RackMapping from './RackMapping/index.vue';

export default {
  name: 'ptl-mapping',
  components: {
    'first': GroupMapping,
    'second': RackMapping
  },
  props: [],
  data() {
    return {
      currentTab: 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'Group Mapping'
        },
        {
          key: 'Second',
          value: 'Rack Mapping'
        }
      ],
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  mounted() {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/PTLMapping/PTLMapping.js